import clsx from 'clsx';
import { forwardRef } from 'react';

import { DataTestId } from '../../../core/types/data-props.js';
import { StylingProps } from '../../../core/types/styling-props.js';
import { WithChildren } from '../../../core/types/with-children.js';
import { canReceiveDefaultTextFormat as _canReceiveDefaultTextFormat } from '../../../core/utils/can-receive-default-text-format.js';
import { Text } from '../../../typography/text/Text.js';
import { detailsSlotCss } from '../EmptyState.sty.js';

//#region Typings
/**
 * @public
 */
export interface EmptyStateDetailsProps
  extends WithChildren, StylingProps, DataTestId {}
//#endregion Typings

/**
 * The Details slot of the EmptyState component.
 * @public
 */
export const Details = /* @__PURE__ */ forwardRef<
  HTMLParagraphElement,
  EmptyStateDetailsProps
>((props, forwardedRef) => {
  const {
    children,
    className: consumerClassName,
    style: consumerStyle,
    'data-testid': dataTestId,
  } = props;

  const attrs = {
    ref: forwardedRef,
    className: clsx([detailsSlotCss, consumerClassName]),
    style: consumerStyle,
    'data-testid': dataTestId,
  };

  return _canReceiveDefaultTextFormat(children) ? (
    <Text textStyle="base" as="p" {...attrs}>
      {children}
    </Text>
  ) : (
    <div {...attrs}>{children}</div>
  );
});

(Details as typeof Details & { displayName: string }).displayName =
  'EmptyState.Details';
